import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { EventTypes } from 'src/app/models/Enums/EventTypes';
import { StineEvent } from 'src/app/models/Enums/StineEvent';

@Component({
  selector: 'stine-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  standalone: true,
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    CommonModule,
    MatButtonModule,
  ],
})
export class TableFilterComponent implements OnInit, OnDestroy {
  @Output() public filterChange: EventEmitter<StineEvent<string>>;

  public filterInputControl: FormControl<string>;
  public subscriptions: Subscription[];

  constructor() {
    this.subscriptions = [];
    this.filterChange = new EventEmitter<StineEvent<string>>();
    this.filterInputControl = new FormControl<string>('');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.filterInputControl.valueChanges
        .pipe(debounceTime(250))
        .subscribe((filterValue: string) => {
          this.filterChange.emit(
            new StineEvent<string>(EventTypes.TextFilter, filterValue),
          );
        }),
    );
  }
}
